import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { USER_GROUPS } from '../models/group';
import { VW_APP_USERS, APP_USERS } from '../models/User';
import { HeaderService } from '../header.service';
import { ProfileService } from '../profile.service';
import * as Globals from '../globals';
declare var $: any;

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {

  userProfile: any;
  groups: USER_GROUPS[];
  user: APP_USERS;
  grpId: number;
  users: VW_APP_USERS[];
  parts: any[];
  authMenu: any;
  loading: boolean;
  search: string = '';
  tab: number = 1;
  p: number = 1;
  reverse: boolean = false;
  colSort: string[] = ['USERNAME'];
  col: number = 1;
  constructor(private http: Http, public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService, private profileService: ProfileService) {
    this.toastr.setRootViewContainerRef(vRef);
    this.authMenu = { M_FLAG: null };
    this.userProfile = { PARENT_GROUP_ID: null };
  }
  sort(val: number) {
    this.col = val;
    this.reverse = !this.reverse;
    switch (val) {
      case 1:
        this.colSort = ['USERNAME'];
        break;
      case 2:
        this.colSort = ['FULLNAME'];
        break;
      case 3:
        this.colSort = ['GROUPNAME'];
        break;
      case 4:
        this.colSort = ['D_EXPIRY'];
        break;
      case 5:
        this.colSort = ['LAST_LOGIN'];
        break;
      default:
        break;
    }
  }
  ngOnInit() {
    this.New();

    if (!this.profileService.userProfile) {
      this.profileService.signOut();
    } else {
      this.subInit();
    }
  }
  subInit() {
    this.userProfile = this.profileService.userProfile;
    this.authMenu = Globals.getAuthPanel(901, this.userProfile);
    this.loading = true;
    this.grpId = this.userProfile.GROUP_ID;
    if (this.userProfile.GROUP_ID > 1) {
      this.grpId = this.userProfile.PARENT_GROUP_ID;
    }
    this.getAppGroup();
  }
  getAppGroup() {
    this.http.get(Globals.serviceUrl + 'ref/appgroup?cdApp=1&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.groups = res.json();
        this.getParts();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  getParts() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ref/parts?inst=1&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.parts = res.json();
        if (this.parts.length > 0) {
          this.user.GROUP_ID = this.parts[0].PA_ID;
        }
        this.getUsers();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  getUsers() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ref/user?cdapp=1&search=' + this.search + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.users = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  New() {
    this.tab = 1;
    this.user = new APP_USERS(0, null, null, '', null, null, null, null, null, null, null, null, null);
  }
  Edit(id: number) {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ref/user?id=' + id + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.user = res.json();
        this.user.PASSWORD = '';
        this.user.REPASSWORD = '';
        //var date = new Date(this.user.SD_EXPIRY);
        //this.user.D_EXPIRY = date;
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  Save() {
    this.loading = true;
    //this.user.SD_EXPIRY = Globals.formatDate(this.user.D_EXPIRY);
    this.user.CREATED_BY = this.userProfile.USER_ID;
    if (this.user.GROUP_ID < 3 || this.user.GROUP_ID > 4) {
      this.user.AP_ID = null;
    }
    if (this.user.USER_ID == 0) {
      this.http.post(Globals.serviceUrl + 'ref/user', this.user, { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          $('#modal').modal('hide');
          this.toastr.success('Data berhasil disimpan');
          this.getUsers();
        }, err => {
          console.log(err);
          if (err.status == 400) {
            this.toastr.error(err.json().Message);
          } else {
            this.toastr.error(Globals.errorMessage(err));
          }

          this.loading = false;
        });
    } else {
      this.http.put(Globals.serviceUrl + 'ref/user?id=' + this.user.USER_ID, this.user, { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          $('#modal').modal('hide');
          this.toastr.success('Data berhasil disimpan');
          this.getUsers();
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
    }
  }
  Delete() {
    this.loading = true;
    this.http.delete(Globals.serviceUrl + 'ref/user?id=' + this.user.USER_ID, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        $('#modal').modal('hide');
        this.toastr.success('Data berhasil dihapus');
        this.getUsers();
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/user/user.component.ts